import * as _hm from './_hm';
import * as _ht from './_ht';

export const r = (
  ls: _ht.ls,
  vle: _ht.a,
) => {
  return _hm.getDz(ls, vle, 'key');
}

export const u = (dz1: _ht.dz, dz2: _ht.dz) => { // update dz
  _hm.udtDz(dz1, {
    ... dz2,
    crlz: {
      ... dz1.crlz ? dz1.crlz : undefined,
      bChg: true,
    }
  });
}; 

export const nfd = (ls: _ht.ls, bFull: _ht.b = true) => { // no delete
  return ls ? ls.filter((_dz: _ht.dz) => (!bFull || _hm.f(_dz)) && _dz._dlt != 1 ) : [];
};
